function syncSelectedOption(select: HTMLSelectElement): void {
	const currentValue = select.value;

	Array.from(select.options).forEach((option) => {
		option.selected = option.value === currentValue;
	});
}

function initEpaperArchive(): void {
	const archiveContainer = document.querySelector<HTMLElement>('.epaperdownloadarchiv');
	if (!archiveContainer) {
		return;
	}

	const yearSelect = archiveContainer.querySelector<HTMLSelectElement>('select.jahr');
	const outputInput = archiveContainer.querySelector<HTMLInputElement>('#download_ausgabe');
	const issueSelects = Array.from(
		archiveContainer.querySelectorAll<HTMLSelectElement>('select[name="tx_ideaepaper_ideaepaper[downloads][ausgaben]"]')
	);

	const setOutputValue = (value: string): void => {
		if (outputInput) {
			outputInput.value = value;
		}
	};

	const hideAllIssueSelects = (): void => {
		issueSelects.forEach((select) => {
			select.classList.add('epaper-issues-select');
			select.classList.remove('is-active');
			select.classList.add('is-hidden');
			select.disabled = true;
			select.style.setProperty('display', 'none', 'important');
		});
	};

	const showIssueSelectForYear = (year: string): void => {
		hideAllIssueSelects();

		const activeIssueSelect = issueSelects.find((select) => select.classList.contains(year));
		if (!activeIssueSelect) {
			return;
		}

		activeIssueSelect.disabled = false;
		activeIssueSelect.classList.remove('is-hidden');
		activeIssueSelect.classList.add('is-active');
		activeIssueSelect.style.setProperty('display', 'block', 'important');
		syncSelectedOption(activeIssueSelect);
		setOutputValue(activeIssueSelect.value);
	};

	if (yearSelect) {
		showIssueSelectForYear(yearSelect.value);

		yearSelect.addEventListener('change', () => {
			showIssueSelectForYear(yearSelect.value);
		});
	}

	issueSelects.forEach((issuesSelect) => {
		issuesSelect.classList.add('epaper-issues-select');
		issuesSelect.addEventListener('change', () => {
			syncSelectedOption(issuesSelect);
			setOutputValue(issuesSelect.value);
		});
	});
}

if (document.readyState === 'loading') {
	document.addEventListener('DOMContentLoaded', initEpaperArchive);
} else {
	initEpaperArchive();
}
